/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar[_ngcontent-%COMP%]{background-color:#fff;min-height:48px}.toolbar__notifications_icon[_ngcontent-%COMP%]{position:relative}.toolbar__notifications_icon--circle[_ngcontent-%COMP%]{border-radius:50%;background-color:#d32f2f;height:7px;width:7px;position:absolute;right:0}.flag[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]     .mat-select-content{width:50px}.username[_ngcontent-%COMP%]{font-size:13px;color:#4e4d4d}"];
export { styles as styles };
